import { EditOrderRescueModal } from "./EditOrderRescueModal";

export const Edit = {
  OrderRescue: EditOrderRescueModal
};
